<template>
    <div class="island-container" v-if="tasks.length > 0 && !isLoginPage">
        <div class="island-pill" :class="{ 'is-expanded': isExpanded }" @mouseenter="isExpanded = true"
            @mouseleave="isExpanded = false">
            <div class="island-compact" v-show="!isExpanded">
                <div class="compact-left">
                    <i class="el-icon-loading island-spinner"></i>
                </div>
                <div class="compact-center">
                    <span class="running-count">{{ tasks.length }}</span> 个任务进行中
                </div>
                <div class="compact-right">
                    <div class="audio-wave">
                        <span></span><span></span><span></span>
                    </div>
                </div>
            </div>

            <div class="island-expanded" v-show="isExpanded">
                <div class="expanded-header">
                    <span class="header-title">正在执行的任务</span>
                    <el-button type="text" class="jump-btn" @click="goToBackhome">
                        前往控制台 <i class="el-icon-arrow-right"></i>
                    </el-button>
                </div>
                <ul class="running-list">
                    <li v-for="task in tasks" :key="task.id" class="running-item">
                        <div class="task-info">
                            <i class="el-icon-loading task-icon"></i>
                            <span class="task-name">{{ task.name }}</span>
                        </div>
                        <span class="task-time">{{ formatTime(task.startTime) }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DynamicIsland',
    data() {
        return {
            tasks: [],
            timer: null,
            isExpanded: false,
            currentUser: null,
            currentRole: ''
        };
    },
    computed: {
        isAdmin() {
            return this.currentRole === 'admin';
        },
        // 修改点2：判断当前是否是登录页
        // 请根据你实际的登录页路由路径修改，通常是 '/login' 或 '/'
        isLoginPage() {
            return this.$route.path === '/login' || this.$route.path === '/';
        }
    },
    mounted() {
        this.initUser();
        // 修改点3：挂载时，如果不是登录页才启动
        if (this.isAdmin && !this.isLoginPage) {
            this.startPolling();
        }
    },
    beforeDestroy() {
        this.stopPolling();
    },
    // 修改点4：监听路由变化，实现自动启停
    watch: {
        $route(to) {
            // 如果去往登录页，立刻停止轮询并清空数据
            if (to.path === '/login' || to.path === '/') {
                this.stopPolling();
                this.tasks = []; // 清空数据，确保 v-if 隐藏
            } else {
                // 如果是从登录页进入系统，重新读取用户并启动
                // 稍微延迟一下，确保 loginResponse 已经写入 localStorage
                setTimeout(() => {
                    this.initUser();
                    if (this.isAdmin) {
                        this.startPolling();
                    }
                }, 500);
            }
        }
    },
    methods: {
        initUser() {
            try {
                const cachedData = JSON.parse(localStorage.getItem('loginResponse'));
                if (cachedData) {
                    this.currentUser = cachedData;
                    this.currentRole = cachedData.role;
                }
            } catch (e) { }
        },
        // 抽离启动逻辑
        startPolling() {
            // 防止重复启动
            if (this.timer) clearInterval(this.timer);

            this.fetchRunningTasks();
            this.timer = setInterval(this.fetchRunningTasks, 3000);
        },
        // 抽离停止逻辑
        stopPolling() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        fetchRunningTasks() {
            // 双重保险：如果是登录页，坚决不发请求
            if (this.isLoginPage) return;

            const payload = {
                id: this.currentUser?.id,
                role: this.currentRole,
            };

            // 如果没取到用户ID（比如刚登出），也不发请求
            if (!payload.id) return;

            this.$request.post('/buUserTask/running', payload).then(res => {
                if (res.code === 200) {
                    this.tasks = res.data.list || [];
                }
            }).catch(() => {
                // 接口报错（比如401）时停止轮询，防止无限报错
                // this.stopPolling(); 
            });
        },
        goToBackhome() {
            if (this.$route.path !== '/backhome') {
                this.$router.push('/backhome');
            }
        },
        formatTime(timeStr) {
            if (!timeStr) return '';
            const date = new Date(timeStr);
            if (isNaN(date.getTime())) return timeStr;
            date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        }
    }
}
</script>

<style scoped>
.island-container {
    position: fixed;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.island-pill {
    background: linear-gradient(135deg,
            rgba(245, 247, 250, 0.85) 0%,
            rgba(255, 255, 255, 0.6) 100%);

    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);

    border: 1px solid rgba(220, 223, 230, 0.6);

    box-shadow:
        0 8px 24px -4px rgba(0, 0, 0, 0.12),
        0 4px 12px -2px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 0 rgba(255, 255, 255, 0.8),
        /* 顶部高光 */
        inset 0 -1px 0 0 rgba(255, 255, 255, 0.4);
    /* 底部反光 */

    border-radius: 24px;
    color: #303133;
    width: 170px;
    height: 38px;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    overflow: hidden;
    cursor: pointer;
    display: flex;
    flex-direction: column;
}

/* 状态：展开时 */
.island-pill.is-expanded {
    width: 340px;
    height: auto;
    min-height: 120px;
    border-radius: 24px;

    background: linear-gradient(135deg,
            rgba(255, 255, 255, 0.95) 0%,
            rgba(242, 246, 252, 0.9) 100%);

    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);

    border: 1px solid rgba(220, 223, 230, 0.8);
    box-shadow:
        0 20px 50px -12px rgba(0, 0, 0, 0.18),
        inset 0 1px 0 0 rgba(255, 255, 255, 1);
}

/* --- 以下内容布局样式基本不变，微调了分割线颜色以适应毛玻璃 --- */

.island-compact {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    padding: 0 15px;
    width: 100%;
    box-sizing: border-box;
}

.compact-left {
    display: flex;
    align-items: center;
}

.island-spinner {
    font-size: 16px;
    color: #409EFF;
    font-weight: bold;
}

.compact-center {
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    color: #606266;
}

.running-count {
    color: #409EFF;
    font-weight: bold;
    font-size: 15px;
    padding: 0 4px;
}

.audio-wave {
    display: flex;
    align-items: center;
    gap: 3px;
    height: 10px;
}

.audio-wave span {
    display: block;
    width: 3px;
    background: #409EFF;
    border-radius: 2px;
    animation: wave 1s infinite ease-in-out;
}

.audio-wave span:nth-child(1) {
    height: 6px;
    animation-delay: 0s;
}

.audio-wave span:nth-child(2) {
    height: 10px;
    animation-delay: 0.1s;
}

.audio-wave span:nth-child(3) {
    height: 7px;
    animation-delay: 0.2s;
}

@keyframes wave {

    0%,
    100% {
        transform: scaleY(1);
        opacity: 0.6;
    }

    50% {
        transform: scaleY(0.4);
        opacity: 1;
    }
}

.island-expanded {
    padding: 15px 20px;
    animation: fadeIn 0.3s ease 0.1s forwards;
    opacity: 0;
}

@keyframes fadeIn {
    to {
        opacity: 1;
    }
}

.expanded-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    /* 分割线改为半透明白色，适应玻璃背景 */
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.header-title {
    font-size: 12px;
    color: #909399;
    font-weight: 500;
}

.jump-btn {
    padding: 0;
    color: #409EFF;
    font-size: 12px;
    font-weight: normal;
}

.jump-btn:hover {
    color: #66b1ff;
}

.running-list {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 200px;
    overflow-y: auto;
}

.running-list::-webkit-scrollbar {
    width: 4px;
}

.running-list::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
}

.running-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    /* 列表分割线也改为半透明 */
    border-bottom: 1px dashed rgba(0, 0, 0, 0.06);
}

.running-item:last-child {
    border-bottom: none;
}

.task-info {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
}

.task-icon {
    color: #E6A23C;
    animation: rotate 2s linear infinite;
    font-size: 14px;
}

.task-name {
    font-size: 14px;
    color: #303133;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    font-weight: 500;
}

.task-time {
    font-size: 12px;
    color: #C0C4CC;
    font-family: monospace;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>